const EventEmitter = require('events');

const JitsiMeetJS = window.JitsiMeetJS;
const JitsiConfig = window.config;

class VBPublisher extends EventEmitter {
    /**
     * 
     * @param {string} conferenceName 
     * @param {string} displayName
     */
    constructor(conferenceName, displayName) {
        super();
        this.conferenceName = conferenceName;
        this.displayName = displayName;

        this._connection = null;
        this._conference = null;
        this._joined = false;
    }

    get connection() {
        return this._connection;
    }

    get conference() {
        return this._conference;
    }

    get room() {
        if (!!this.conference && !!this.conference.room) {
            return this.conference.room;
        }
        return null;
    }

    get joined() {
        return !!this.conference && !!this.conference.room && !!this.conference.room.joined;
    }

    get connectionTimes() {
        if (!!this.room && !!this.room.connectionTimes) {
            return this.room.connectionTimes;
        }
        return null;
    }

    get members() {
        if (!!this.room && !!this.room.members) {
            return this.room.members;
        }
        return null;
    }

    get connected() {
        let _connected = this.conference && this.room && this.conference.getConnectionState() === 'connected';
        if (_connected) {
            let isJvbConnectionInterrupted = !!this.conference.isJvbConnectionInterrupted;
            let isP2PConnectionInterrupted = !!this.conference.isP2PConnectionInterrupted;
            if (!!isJvbConnectionInterrupted) return false;
            if (!!isP2PConnectionInterrupted) return false;
        }
        return _connected;
    }

    connect() {
        let connectionOptions = JSON.parse(JSON.stringify(JitsiConfig));
        connectionOptions.serviceUrl = (connectionOptions.websocket || connectionOptions.bosh) + `?room=${this.conferenceName}`;
        if (connectionOptions.websocketKeepAliveUrl) {
            connectionOptions.websocketKeepAliveUrl += `?room=${this.conferenceName}`;
        }

        this._connection = new JitsiMeetJS.JitsiConnection(null, null, connectionOptions);

        this.connection.addEventListener(JitsiMeetJS.events.connection.CONNECTION_ESTABLISHED, () => {
            console.log('CONNECTION_ESTABLISHED', this.displayName);
            this.emitEvent(JitsiMeetJS.events.connection.CONNECTION_ESTABLISHED);
            this._conference = this.connection.initJitsiConference(this.conferenceName, { displayName: this.displayName });
            this.handleConferenceEvents();
            this.conference.setDisplayName(this.displayName);
            this.conference.join();

        });

        this.connection.addEventListener(JitsiMeetJS.events.connection.CONNECTION_FAILED, () => {
            console.log(`CONNECTION_FAILED`, this.displayName);
            this.emitEvent(JitsiMeetJS.events.connection.CONNECTION_FAILED);
        });

        this.connection.addEventListener(JitsiMeetJS.events.connection.CONNECTION_INTERRUPTED, () => {
            console.log(`CONNECTION_INTERRUPTED`, this.displayName);
            this.emitEvent(JitsiMeetJS.events.connection.CONNECTION_INTERRUPTED);
        });

        this.connection.addEventListener(JitsiMeetJS.events.connection.CONNECTION_RESTORED, () => {
            console.log(`CONNECTION_RESTORED`, this.displayName);
            this.emitEvent(JitsiMeetJS.events.connection.CONNECTION_RESTORED);
        });

        this.connection.addEventListener(JitsiMeetJS.events.connection.CONNECTION_DISCONNECTED, () => {
            console.log(`CONNECTION_DISCONNECTED`, this.displayName);
            this.emitEvent(JitsiMeetJS.events.connection.CONNECTION_DISCONNECTED);
            // this.disconnect();
        });

        this.connection.connect();
    }

    dispose() {
        if (!!this.conference) {
            this.conference.leave();
        }
        if (!!this.connection) {
            this.connection.disconnect();
        }
    }

    handleConferenceEvents() {
        this.conference.on(JitsiMeetJS.events.conference.TRACK_REMOVED, (track) => {
            // console.log(`TRACK_REMOVED: ${track}`);
        });

        this.conference.on(JitsiMeetJS.events.conference.CONFERENCE_JOINED, () => {
            console.log(`CONFERENCE_JOINED`, this.displayName);
            this.emitEvent(JitsiMeetJS.events.conference.CONFERENCE_JOINED);
        });

        this.conference.on(JitsiMeetJS.events.conference.CONFERENCE_LEFT, () => {
            console.log(`CONFERENCE_LEFT`, this.displayName);
            this.emitEvent(JitsiMeetJS.events.conference.CONFERENCE_LEFT);
        });

        this.conference.on(JitsiMeetJS.events.conference.CONFERENCE_FAILED, () => {
            console.log(`CONFERENCE_FAILED`, this.displayName);
            this.emitEvent(JitsiMeetJS.events.conference.CONFERENCE_FAILED);
        });

        this.conference.on(JitsiMeetJS.events.conference.CONFERENCE_ERROR, () => {
            console.log(`CONFERENCE_ERROR`, this.displayName);
            this.emitEvent(JitsiMeetJS.events.conference.CONFERENCE_ERROR);
        });

        this.conference.on(JitsiMeetJS.events.conference.USER_JOINED, (id) => {
            console.log(`USER_JOINED`, this.displayName, id);
            this.emitEvent(JitsiMeetJS.events.conference.USER_JOINED);
        });

        this.conference.on(JitsiMeetJS.events.conference.USER_LEFT, (id) => {
            console.log(`USER_LEFT`, this.displayName, id);
            this.emitEvent(JitsiMeetJS.events.conference.USER_LEFT);
        });
    }

    emitEvent(event, params) {
        this.emit('VBPublisher:events', {
            'event': event,
            'params': params
        });
    }
}

export default VBPublisher;